import React from "react";
import PropTypes from "prop-types";

import * as theme3Styles from "../scss/theme3.module.scss";

const Welcome = ({ title, text, logo }) => {
  return (
    <div className={theme3Styles.welcomeBox}>
      {logo && (
        <div className={theme3Styles.icon}>
          <img src={logo} />
        </div>
      )}
      {(title || text) && (
        <div className={theme3Styles.details}>
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      )}
    </div>
  );
};

Welcome.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  logo: PropTypes.string,
};

export default Welcome;
